import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';
import { NAME_SPACE } from 'i18n';
import { ViewTable, execConfirmModal, ButtonAdd, ButtonDelete } from 'shared';
import { useReadersPaginated } from './useReadersPaginated';
import { useReadersBuildTable } from './useReadersBuildTable';
import { useListReadersStyles } from './listReaders.styles';
import { PATH } from 'app.routes.const';

export function ListReaders() {
  const classes = useListReadersStyles();
  const { readers, getReaders, deleteReaders, errorInfo } = useReadersPaginated();
  const { t } = useTranslation(NAME_SPACE.READERS);
  const history = useHistory();

  const { rows, headCells } = useReadersBuildTable(readers, t);

  function handleEdit([readerId]) {
    history.push(PATH.READERS.EDIT.replace(':id', readerId));
  }

  function handleAdd() {
    history.push(PATH.READERS.CREATE);
  }

  async function handleDelete(readersToDelete) {
    try {
      await execConfirmModal({
        title: t('common:actions.remove'),
        description:
          readersToDelete.length > 1
            ? t('removeConfirm.message', { length: readersToDelete.length })
            : t('removeConfirm.singularMessage', {
                name: readersToDelete[0].name
              }),
        confirmText: t('common:actions.accept'),
        declineText: t('common:actions.cancel'),
        confirmClassName: classes.buttonAdd,
        declineClassName: classes.buttonDelete
      });
      await deleteReaders(readersToDelete);
    } catch (err) {}
  }

  return (
    <div className={classes.readers}>
      <ViewTable
        elevation
        spaced
        errors={errorInfo}
        rows={rows}
        cells={headCells}
        defaultOrderBy={{ property: 'name', direction: 'asc' }}
        mainKey={'name'}
        onFetchData={getReaders}
        totalRows={readers.total}
        selectRowWhen={element => element.canBeDeleted}
        serverSidePaging
        emptyText={t('empty')}
        actions={[
          {
            title: t('actions.edit'),
            name: 'edit',
            properties: ['id'],
            label: 'edit this row',
            cb: handleEdit,
            icon: <EditIcon />
          }
        ]}
        toolbar={{
          title: t('name'),
          actions: [
            {
              condition: isAnySelected => !isAnySelected,
              cb: handleAdd,
              component: ButtonAdd
            },
            {
              condition: isAnySelected => isAnySelected,
              resetOnCB: true,
              cb: handleDelete,
              component: ButtonDelete
            }
          ]
        }}
      />
    </div>
  );
}
